document.addEventListener("DOMContentLoaded", function () {
  const sideCart = document.getElementById("side-cart");
  const overlay = sideCart?.querySelector(".side-cart-overlay");
  const closeBtn = document.getElementById("close-side-cart");
  const itemsContainer = document.getElementById("side-cart-items");
  const openSideCartBtn = document.querySelector(".site-header-cart");
  const constinueShoppingBtn = document.querySelector(".continue-shipping");

  document.addEventListener("upsell:added", (e) => {
    updateContentCart();
    updateCount();
  });

  // Function to open side cart
  function openSideCart() {
    sideCart?.classList.add("open");
    sideCart?.classList.remove("hidden");
    updateContentCart();
    updateCount();
    togglePSWidget();

    document.body.classList.add("overflow-y-hidden");
  }

  // Function to hide the PS widget
  function togglePSWidget() {
    const psWidget = document.querySelector("#ps__widget");
    if (psWidget) {
      psWidget.classList.toggle("hidden");
    }
  }

  //Function to update content side cart
  function updateContentCart() {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        if (!itemsContainer) return;

        // Generate cart-level discounts HTML
        let cartDiscountsHTML = "";
        if (
          cart.cart_level_discount_applications &&
          cart.cart_level_discount_applications.length > 0
        ) {
          cartDiscountsHTML = `
            <div class="cart-discounts-container">
              ${cart.cart_level_discount_applications
                .map(
                  (discount) => `
                <div class="cart-discount-item">
                  <span class="cart-discount-title">🏷️ ${discount.title}</span>
                  <span class="cart-discount-amount">-${new Intl.NumberFormat(
                    "en-US",
                    { style: "currency", currency: "USD" }
                  ).format(discount.total_allocated_amount / 100)}</span>
                </div>
              `
                )
                .join("")}
            </div>
          `;
        }

        itemsContainer.innerHTML =
          cartDiscountsHTML +
          cart.items
            .map(
              (item) => `
        <div class="cart-item-side-cart" data-line="${item.id}">
          <img class="item-image-side-cart" src="${item.image}" alt="${
                item.title
              }" width="50">

          <div class="container-info-side-cart-mobile">

            <div class="container-title-close-icon">
              <p class="item-title-side-cart">${item.product_title}</p>
              <svg class="item-icon-remove" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g clip-path="url(#clip0_2704_489)">
                  <path d="M15 9L9 15" stroke="#565656" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9 9L15 15" stroke="#565656" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" fill="#565656" fill-opacity="0.2"/>
                </g>
                <defs>
                  <clipPath id="clip0_2704_489">
                    <rect width="24" height="24" fill="white"/>
                  </clipPath>
                </defs>
              </svg>
            </div>

            <div class="container-qty-variant">
              <select id="quantity-item-side-cart" name="quantity">
                ${[...Array(10)]
                  .map((_, i) => {
                    const value = i + 1;
                    return `<option value="${value}" ${
                      item.quantity === value ? "selected" : ""
                    }>${value}</option>`;
                  })
                  .join("")}
              </select>
              <p class="item-info-side-cart-variant">
                ${
                  item.options_with_values[0].name != "Title"
                    ? `${item.options_with_values[0].name}: <span>${item.options_with_values[0].value}</span>`
                    : ""
                }
              </p>
            </div>

            <div class="container-discount-price ${
              item.line_level_discount_allocations &&
              item.line_level_discount_allocations.length > 0 &&
              item.line_level_discount_allocations[0].discount_application.title
                ? `with-discount`
                : ""
            }">
              ${
                item.line_level_discount_allocations &&
                item.line_level_discount_allocations.length > 0 &&
                item.line_level_discount_allocations[0].discount_application
                  .title
                  ? `<p class="text-discount-item-side-cart">${item.line_level_discount_allocations[0].discount_application.title}</p>`
                  : ""
              }
              <div class="container-price-discount">
                ${
                  item.line_level_discount_allocations &&
                  item.line_level_discount_allocations.length > 0 &&
                  item.line_level_discount_allocations[0].discount_application
                    .title
                    ? `<div class="item-side-cart-original-price">${new Intl.NumberFormat(
                        "en-US",
                        { style: "currency", currency: "USD" }
                      ).format(item.original_price / 100)}</div>`
                    : ""
                }
                <div class="item-side-cart-price">${new Intl.NumberFormat(
                  "en-US",
                  { style: "currency", currency: "USD" }
                ).format(item.final_price / 100)}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="cart-item-side-cart-mobile" data-line="${item.id}">
          <img class="item-image-side-cart" src="${item.image}" alt="${
                item.title
              }" width="50">

          <div class="container-info-side-cart-mobile">
            <p class="item-title-side-cart">${item.product_title}</p>
              <p class="item-info-side-cart-variant">
                ${
                  item.options_with_values[0].name != "Title"
                    ? `${item.options_with_values[0].name}: <span>${item.options_with_values[0].value}</span>`
                    : ""
                }
              </p>
            <div class="rtm">
              <div class="container-quantity-price">
                <div class="container-quantity-discount">
                  <select id="quantity-item-side-cart" name="quantity">
                    ${[...Array(10)]
                      .map((_, i) => {
                        const value = i + 1;
                        return `<option value="${value}" ${
                          item.quantity === value ? "selected" : ""
                        }>${value}</option>`;
                      })
                      .join("")}
                  </select>
                  ${
                    item.line_level_discount_allocations &&
                    item.line_level_discount_allocations.length > 0 &&
                    item.line_level_discount_allocations[0].discount_application
                      .title
                      ? `<p class="text-discount-item-side-cart">${item.line_level_discount_allocations[0].discount_application.title}</p>`
                      : ""
                  }
                </div>
                <div class="container-price-discount">
                  ${
                    item.line_level_discount_allocations &&
                    item.line_level_discount_allocations.length > 0 &&
                    item.line_level_discount_allocations[0].discount_application
                      .title
                      ? `<div class="item-side-cart-original-price">${new Intl.NumberFormat(
                          "en-US",
                          { style: "currency", currency: "USD" }
                        ).format(item.original_price / 100)}</div>`
                      : ""
                  }
                  <div class="item-side-cart-price">${new Intl.NumberFormat(
                    "en-US",
                    { style: "currency", currency: "USD" }
                  ).format(item.final_price / 100)}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="container-close-icon">
            <svg class="item-icon-remove-mobile" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <g clip-path="url(#clip0_2704_489)">
                <path d="M15 9L9 15" stroke="#565656" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9 9L15 15" stroke="#565656" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" fill="#565656" fill-opacity="0.2"/>
              </g>
              <defs>
                <clipPath id="clip0_2704_489">
                  <rect width="24" height="24" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      `
            )
            .join("");
      });
  }

  // Function to close side cart
  function closeSideCart() {
    sideCart?.classList.remove("open");
    sideCart?.classList.add("hidden");
    updateCount();
    reActivateAddToCartBtn();
    togglePSWidget();

    document.body.classList.remove("overflow-y-hidden");
  }

  //Function to update content cart when the cart is updated
  function updateCount() {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        // Update both UI elements and full cart content including discounts
        refreshCartUI(cart);
        updateContentCart();
      })
      .catch((error) => {
        console.error("Error al obtener los datos del carrito:", error);
      });
  }

  // Function to update cart item quantity
  function updateCartItemQuantity(line, quantity, validation) {
    const payload = {
      updates: {},
    };
    payload.updates[line] = quantity;

    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((cart) => {
        // Update UI elements (price, count) and full cart content (including discounts)
        refreshCartUI(cart);
        updateContentCart();
        if (validation === 1) {
          const event = new CustomEvent("product:deleted");
          document.dispatchEvent(event);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  //Function to refresh the cart UI quantity and total price
  function refreshCartUI(cart) {
    document.querySelector(".number-total").textContent = new Intl.NumberFormat(
      "en-US",
      { style: "currency", currency: "USD" }
    ).format(cart.total_price / 100);
    document.querySelector(".text-total span").textContent = cart.item_count;
    updateIconHeaderQuantity(cart);
  }

  //Function to update icon header quantity
  function updateIconHeaderQuantity(cart) {
    const cartCount = cart.item_count;
    const cartElement = document.querySelector("[data-header-cart-count]");
    if (cartElement) {
      cartElement.setAttribute("data-header-cart-count", cartCount.toString());
    }
  }

  //function to close side cart when clicking outside of it and in close button
  overlay?.addEventListener("click", closeSideCart);
  closeBtn?.addEventListener("click", closeSideCart);
  constinueShoppingBtn?.addEventListener("click", closeSideCart);

  //Function to reactivate btn add to cart in pdp
  function reActivateAddToCartBtn() {
    const addToCartBtn = document.querySelector(".product-form--atc-button");
    if (addToCartBtn) {
      if (addToCartBtn.classList.contains("processing")) {
        addToCartBtn.classList.remove("processing");
        addToCartBtn.removeAttribute("disabled");
      }
    }
  }

  // Add event listener to all forms that add items to the cart
  document.querySelectorAll('form[action^="/cart/add"]').forEach((form) => {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      const formData = new FormData(form);
      fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      }).then(() => {
        openSideCart();
        const event = new CustomEvent("product:added");
        document.dispatchEvent(event);
      });
    });
  });

  // Open side cart when clicking on the cart icon
  openSideCartBtn?.addEventListener("click", function (e) {
    e.preventDefault();
    if (sideCart?.classList.contains("hidden")) {
      openSideCart();
    }
  });

  // Event listeners for quantity change
  itemsContainer.addEventListener("change", (e) => {
    if (e.target.name === "quantity") {
      console.log("Item a cambiado cantidad");
      const quantity = parseInt(e.target.value, 10);
      const itemElement = e.target.closest(".cart-item-side-cart");
      const itemElementMobile = e.target.closest(".cart-item-side-cart-mobile");

      if (itemElement) {
        const lineId = parseInt(itemElement.dataset.line, 10);
        updateCartItemQuantity(lineId, quantity, 0);
      }

      if (itemElementMobile) {
        const lineId = parseInt(itemElementMobile.dataset.line, 10);
        updateCartItemQuantity(lineId, quantity, 0);
      }
    }
  });

  // Event listener for delete icon
  itemsContainer.addEventListener("click", (e) => {
    const deleteIcon = e.target.closest(".item-icon-remove");
    const deleteIconMobile = e.target.closest(".item-icon-remove-mobile");
    if (deleteIcon) {
      console.log("Desde 1");
      const itemElement = deleteIcon.closest(".cart-item-side-cart");
      const lineId = parseInt(itemElement.dataset.line, 10);
      updateCartItemQuantity(lineId, 0, 1);
    }
    if (deleteIconMobile) {
      console.log("Desde 2");
      const itemElement = deleteIconMobile.closest(
        ".cart-item-side-cart-mobile"
      );
      const lineId = parseInt(itemElement.dataset.line, 10);
      updateCartItemQuantity(lineId, 0, 1);
    }
  });

  // Observer for detecting when #ps__widget is added to the DOM
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      const psWidget = document.querySelector("#ps__widget");
      if (psWidget) {
        if (sideCart?.classList.contains("open")) {
          psWidget.classList.add("hidden");
        } else {
          psWidget.classList.remove("hidden");
        }

        observer.disconnect();
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
